/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { AccommodationService } from './services/AccommodationService';
import { AccommodationIdService } from './services/AccommodationIdService';
import { AccommodationPointsService } from './services/AccommodationPointsService';
import { AccommodationPositionService } from './services/AccommodationPositionService';
import { AccommodationsForMapService } from './services/AccommodationsForMapService';
import { AccommodationStatsService } from './services/AccommodationStatsService';
import { AppleAppSiteAssociationControllerService } from './services/AppleAppSiteAssociationControllerService';
import { AssetLinksControllerService } from './services/AssetLinksControllerService';
import { AutocompleteTermService } from './services/AutocompleteTermService';
import { BreadcrumbsService } from './services/BreadcrumbsService';
import { CategoryService } from './services/CategoryService';
import { ConnectionCheckerService } from './services/ConnectionCheckerService';
import { DetectLevelService } from './services/DetectLevelService';
import { GeoPolygonService } from './services/GeoPolygonService';
import { HandleService } from './services/HandleService';
import { LinkspaceService } from './services/LinkspaceService';
import { ListingMetricsService } from './services/ListingMetricsService';
import { ListingOneAlgorithmSimulationService } from './services/ListingOneAlgorithmSimulationService';
import { ListingOtaSimulationService } from './services/ListingOtaSimulationService';
import { ListingSettingService } from './services/ListingSettingService';
import { ListingSimulationService } from './services/ListingSimulationService';
import { ListingStrategyService } from './services/ListingStrategyService';
import { ListingTileService } from './services/ListingTileService';
import { MessengerStatsService } from './services/MessengerStatsService';
import { OtaAccommodationMetricsService } from './services/OtaAccommodationMetricsService';
import { RunCommandInputService } from './services/RunCommandInputService';
import { SingleAccommodationForMapService } from './services/SingleAccommodationForMapService';
import { StorageCheckerService } from './services/StorageCheckerService';
import { SynchronizeService } from './services/SynchronizeService';
import { TestService } from './services/TestService';
import { TilingConfigOutputService } from './services/TilingConfigOutputService';
import { UrlDetailsService } from './services/UrlDetailsService';
import { UserService } from './services/UserService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class NocApiClient {
    public readonly accommodation: AccommodationService;
    public readonly accommodationId: AccommodationIdService;
    public readonly accommodationPoints: AccommodationPointsService;
    public readonly accommodationPosition: AccommodationPositionService;
    public readonly accommodationsForMap: AccommodationsForMapService;
    public readonly accommodationStats: AccommodationStatsService;
    public readonly appleAppSiteAssociationController: AppleAppSiteAssociationControllerService;
    public readonly assetLinksController: AssetLinksControllerService;
    public readonly autocompleteTerm: AutocompleteTermService;
    public readonly breadcrumbs: BreadcrumbsService;
    public readonly category: CategoryService;
    public readonly connectionChecker: ConnectionCheckerService;
    public readonly detectLevel: DetectLevelService;
    public readonly geoPolygon: GeoPolygonService;
    public readonly handle: HandleService;
    public readonly linkspace: LinkspaceService;
    public readonly listingMetrics: ListingMetricsService;
    public readonly listingOneAlgorithmSimulation: ListingOneAlgorithmSimulationService;
    public readonly listingOtaSimulation: ListingOtaSimulationService;
    public readonly listingSetting: ListingSettingService;
    public readonly listingSimulation: ListingSimulationService;
    public readonly listingStrategy: ListingStrategyService;
    public readonly listingTile: ListingTileService;
    public readonly messengerStats: MessengerStatsService;
    public readonly otaAccommodationMetrics: OtaAccommodationMetricsService;
    public readonly runCommandInput: RunCommandInputService;
    public readonly singleAccommodationForMap: SingleAccommodationForMapService;
    public readonly storageChecker: StorageCheckerService;
    public readonly synchronize: SynchronizeService;
    public readonly test: TestService;
    public readonly tilingConfigOutput: TilingConfigOutputService;
    public readonly urlDetails: UrlDetailsService;
    public readonly user: UserService;
    public readonly request: BaseHttpRequest;
    constructor(
        config?: Partial<OpenAPIConfig>,
        HttpRequest: HttpRequestConstructor = AxiosHttpRequest,
    ) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0.1.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.accommodation = new AccommodationService(this.request);
        this.accommodationId = new AccommodationIdService(this.request);
        this.accommodationPoints = new AccommodationPointsService(this.request);
        this.accommodationPosition = new AccommodationPositionService(this.request);
        this.accommodationsForMap = new AccommodationsForMapService(this.request);
        this.accommodationStats = new AccommodationStatsService(this.request);
        this.appleAppSiteAssociationController = new AppleAppSiteAssociationControllerService(
            this.request,
        );
        this.assetLinksController = new AssetLinksControllerService(this.request);
        this.autocompleteTerm = new AutocompleteTermService(this.request);
        this.breadcrumbs = new BreadcrumbsService(this.request);
        this.category = new CategoryService(this.request);
        this.connectionChecker = new ConnectionCheckerService(this.request);
        this.detectLevel = new DetectLevelService(this.request);
        this.geoPolygon = new GeoPolygonService(this.request);
        this.handle = new HandleService(this.request);
        this.linkspace = new LinkspaceService(this.request);
        this.listingMetrics = new ListingMetricsService(this.request);
        this.listingOneAlgorithmSimulation = new ListingOneAlgorithmSimulationService(this.request);
        this.listingOtaSimulation = new ListingOtaSimulationService(this.request);
        this.listingSetting = new ListingSettingService(this.request);
        this.listingSimulation = new ListingSimulationService(this.request);
        this.listingStrategy = new ListingStrategyService(this.request);
        this.listingTile = new ListingTileService(this.request);
        this.messengerStats = new MessengerStatsService(this.request);
        this.otaAccommodationMetrics = new OtaAccommodationMetricsService(this.request);
        this.runCommandInput = new RunCommandInputService(this.request);
        this.singleAccommodationForMap = new SingleAccommodationForMapService(this.request);
        this.storageChecker = new StorageCheckerService(this.request);
        this.synchronize = new SynchronizeService(this.request);
        this.test = new TestService(this.request);
        this.tilingConfigOutput = new TilingConfigOutputService(this.request);
        this.urlDetails = new UrlDetailsService(this.request);
        this.user = new UserService(this.request);
    }
}
